<div class="info-action dropdown-content-root">
	<div class="dropdown-title">
		<p class="title">{{ 'positionInfo.dropdownTitle' | translate }}</p>

		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="dropdown-subtitle">
		<div
			class="left"
			[tuiSkeleton]="isLoadingAssetInfo()"
		>
			<app-company-logo
				[logoSrc]="assetsInfo()?.icon"
				[symbol]="assetsInfo()?.ticker"
				logoWidth="36px"
				logoHeight="36px"
				[logoAlt]="assetsInfo()?.ticker"
			/>
			<div class="name">
				<div class="top">
					<p class="ticker">{{ assetsInfo()?.ticker }}</p>
					<p class="exchange">{{ assetsInfo()?.exchange }}</p>
				</div>
				<p class="description">{{ assetsInfo()?.description }}</p>
			</div>
		</div>

		<div class="right">
			<span class="value">{{ tickerPrices()?.price | price }}</span>

			<div
				class="statistic"
				[tuiSkeleton]="isLoadingAssetInfo()"
			>
				@if ((liveTicker()?.marketStatusPrices?.changeMoney ?? 0) !== 0) {
					<app-profit-triangle [value]="liveTicker()?.marketStatusPrices?.changeMoney ?? 0" />
				}

				<span
					class="value"
					highlight
					[isPositive]="(liveTicker()?.marketStatusPrices?.changeMoney ?? 0) > 0"
					[isNegative]="(liveTicker()?.marketStatusPrices?.changeMoney ?? 0) < 0"
					[isNeutral]="!liveTicker()?.marketStatusPrices?.changeMoney"
				>
					{{ liveTicker()?.marketStatusPrices?.changeMoney | price }}
				</span>
				<span
					class="value"
					highlight
					[isPositive]="(liveTicker()?.marketStatusPrices?.changePercent ?? 0) > 0"
					[isNegative]="(liveTicker()?.marketStatusPrices?.changePercent ?? 0) < 0"
					[isNeutral]="!liveTicker()?.marketStatusPrices?.changePercent"
				>
					{{ liveTicker()?.marketStatusPrices?.changePercent | profit: 'percent' }}
				</span>
			</div>
		</div>
	</div>

	<div class="option">
		<div class="detail">
			<span class="title">{{ 'positionInfo.option' | translate }}</span>
			<span
				class="value"
				highlight
				[isPositive]="position()?.option_type === optionTypeEnum.CALL"
				[isNegative]="position()?.option_type === optionTypeEnum.PUT"
			>
				{{ position()?.option_type | uppercase }}</span
			>
		</div>
		<div class="detail">
			<span class="title">{{ 'positionInfo.strike' | translate }}</span>
			<span class="value">{{ position()?.option_strike | price }}</span>
		</div>
		<div class="detail">
			<span class="title">{{ 'positionInfo.expiration' | translate }}</span>
			<span class="value">{{ position()?.option_date | date: 'dd.MM.yyyy' }}</span>
		</div>
	</div>

	<div class="detail profit">
		<div class="title-box">
			<p class="title">{{ 'positionInfo.profitToday' | translate }},</p>
			<span class="currency">{{ 'positionInfo.USD' | translate }}</span>
		</div>
		<div class="right">
			<span
				highlight
				[isPositive]="+(position()?.unrealized_intraday_pl ?? 0) > 0"
				[isNegative]="+(position()?.unrealized_intraday_pl ?? 0) < 0"
				[isNeutral]="!position()?.unrealized_intraday_pl"
				class="value"
				>{{ position()?.unrealized_intraday_pl | price }}</span
			>
			<span class="value percent">{{ +(position()?.unrealized_intraday_plpc ?? 0) | profit: 'percent' }}</span>
		</div>
	</div>

	<div class="detail profit">
		<div class="title-box">
			<p class="title">{{ 'positionInfo.profitAllTime' | translate }},</p>
			<span class="currency">{{ 'positionInfo.USD' | translate }}</span>
		</div>
		<div class="right">
			<span
				highlight
				[isPositive]="+(position()?.unrealized_pl ?? 0) > 0"
				[isNegative]="+(position()?.unrealized_pl ?? 0) < 0"
				[isNeutral]="!position()?.unrealized_pl"
				class="value"
				>{{ position()?.unrealized_pl | price }}</span
			>
			<span class="value percent">{{ +(position()?.unrealized_plpc ?? 0) | profit: 'percent' }}</span>
		</div>
	</div>

	<div class="details">
		<div class="detail">
			<p class="title">{{ 'positionInfo.type' | translate }}</p>
			<span
				highlight
				class="value"
				[isPositive]="position()?.side === positionSideEnum.LONG"
				[isNegative]="position()?.side === positionSideEnum.SHORT"
				>{{ position()?.side || '-' | uppercase }}</span
			>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.entryPrice' | translate }}</p>
			<span class="value">{{ position()?.avg_entry_price | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.quantityAndSharesPerContract' | translate }}</p>
			<span class="value">{{ position()?.qty | quantity }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.balanceSheet' | translate }}</p>
			<span class="value">{{ position()?.cost_basis | price }}</span>
		</div>
		<div class="detail">
			<p class="title">{{ 'positionInfo.currentPrice' | translate }}</p>
			<span class="value">{{ position()?.current_price | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.currentCost' | translate }}</p>
			<span class="value">{{ position()?.market_value | price }}</span>
		</div>

		<div class="detail">
			<p class="title">{{ 'positionInfo.share' | translate }}</p>
			<span class="value">{{ position()?.portfolio_allocation | percent: true }}</span>
		</div>
	</div>
</div>
